import * as R from 'ramda';
import { FORM_ACTION, SharingOption } from '../FormSettings/constants'

function capitalize (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const sortOrgs = (organizations) => {
    if (!organizations) return [];
    return R.pipe(
        R.map(R.evolve({name: capitalize})),
        R.sortWith([R.ascend(R.prop('name'))])
    )(organizations);
}


export const updateOrgs = (value, checked, orgIds) => {
    const id = parseInt(value)
    const ids = R.without([id], orgIds);
    return checked ? [ ...ids, id ] : ids;
}

export const isOrganizationsDefined = (organizations) => {
    return (organizations && (organizations.length > 0)) ? true : false;
}

export const isEditAction = (action) => {
    return action === FORM_ACTION.edit;
}

export const isCopyAction = (action) => {
    return action === FORM_ACTION.copy;
}

export const isCancelAction = (action) => {
    return action === FORM_ACTION.cancel;
}

export const getTitle = (action) => {
    switch (action) {
        case FORM_ACTION.create: return 'Create New Form';
        case FORM_ACTION.edit: return 'Form Settings';
        case FORM_ACTION.copy: return 'Copy Form';
        default: break;
    }
    return '';
}

export const getActionText = (action, isFormOwner) => {
    const bodyText = ' name, description, active period and options for this form';
    switch (action) {
        case FORM_ACTION.create: return `Set ${bodyText}`;
        case FORM_ACTION.copy: return `Copy ${bodyText}`;
        case FORM_ACTION.edit: return isFormOwner ? `Edit ${bodyText}` : 'Only form owner can modify settings';
        default: break;
    }
    return '';
}

export const getCopiedFormName = (formName) => {
    if (formName)
        return `Copy of ${formName}`;
    return formName;
}

export const getSharingOption = (form, isOrgsDefined) => {
    return (! isOrgsDefined) || (! form.publish) ? SharingOption.NO_SHARE : form.publish;
}

